const tr = {
  files:{
    attributes:{
      id: 'ID',
      name: 'Nome',
      pack_type: 'Adicional',
      key: 'Chave',
      order: 'Ordem',
      url: 'URL',
      is_active: 'Ativo',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras:{
      create: 'Novo',
      edit: 'Editando',
      show: 'Visualizando',
      delete: 'Excluir',
    },
    defSingular: 'Arquivo',
    defPlural: 'Arquivos',
  }
};

export default tr;
